import DateUtils from "@gap/utils/date-utils";
import { downloadFileFromUrl } from "@gap/utils/file/download-file";
import { makeAutoObservable } from "mobx";
import Loader from "reusable/mobx-helpers/Loader";
import PrintStore from "reusable/printing/PrintStore";

interface DownloadPdfButtonStoreParams {
   printStore: PrintStore
   docTitle: string
   documentUrl?: string | undefined
   docId?: string | undefined
}

export default class DownloadPdfButtonStore {
   sp
   loader = new Loader()

   constructor(sp: DownloadPdfButtonStoreParams) {
      makeAutoObservable(this)
      this.sp = sp
   }

   download = async () => {
      await this.loader.executeLoading(async () => {
         try {
            if (this.sp.documentUrl) {
               downloadFileFromUrl(this.sp.documentUrl, this.sp.docTitle)
            } else {
               if (this.sp.docId) {
                  const documentUrl = await this.sp.printStore.waitForGeneration(this.sp.docId)
                  if (documentUrl) {
                     return downloadFileFromUrl(documentUrl, this.sp.docTitle)
                  }
               } else {
                  await this.sp.printStore.downloadCurrentPageAsPdf(this.sp.docTitle)
                  await DateUtils.wait(5000)
               }
            }
         } catch { }
      })
   }
}
